/**
 * Sanoltra Exit-Intent Popup
 * - Trigger: 30s timer OR mouse-leave (desktop) OR scroll-up 50% on mobile
 * - Storage: localStorage 'sanoltra_popup_seen' (90d)
 * - Klaviyo Subscribe API: public client endpoint, no auth needed
 * - List: Newsletter Signups (VcRiwJ)
 */
(function () {
  'use strict';

  var KLAVIYO_COMPANY_ID = 'WUVcyz';
  var NEWSLETTER_LIST_ID = 'VcRiwJ';
  var STORAGE_KEY = 'sanoltra_popup_seen';
  var STORAGE_DAYS = 14; // was 90d
  var TIMER_MS = 20000; // 20s (was 8s) — cerez karari icin zaman birak, gec tetikle
  // WELCOME15 kaldirildi (02 Haz) - lead magnet artik ucretsiz Aile Saglik Rehberi PDF

  var overlay = null;
  var triggered = false;

  function $(id) { return document.getElementById(id); }

  // Cerez banti/tercih modali aciksa popup onu ORTMESIN — karar verilene kadar bekle.
  // 12 Agu 2026: temanin kendi banti kaldirildi, rizayi Shopify'in kendi banti topluyor.
  // Eski kontrol #san-cookie-banner ariyordu; o oge artik yok oldugu icin koruma
  // sessizce devre disi kalmisti ve rehber popup'i cerez bandinin uzerine biniyordu.
  function cookieBarOpen() {
    var gorunur = function (el) {
      if (!el) return false;
      var st = window.getComputedStyle(el);
      return st.display !== 'none' && st.visibility !== 'hidden' && el.getBoundingClientRect().height > 0;
    };
    return gorunur(document.getElementById('shopify-pc__banner'))
        || gorunur(document.getElementById('shopify-pc__prefs'))
        || gorunur(document.querySelector('.shopify-pc__banner__dialog'))
        || gorunur(document.querySelector('.shopify-pc__prefs__dialog'));
  }

  function isSeen() {
    try {
      var v = localStorage.getItem(STORAGE_KEY);
      if (!v) return false;
      var ts = parseInt(v, 10);
      if (isNaN(ts)) return false;
      var ageDays = (Date.now() - ts) / (1000 * 60 * 60 * 24);
      return ageDays < STORAGE_DAYS;
    } catch (e) { return false; }
  }

  function markSeen() {
    try { localStorage.setItem(STORAGE_KEY, String(Date.now())); } catch (e) {}
  }

  function show() {
    if (triggered) return;
    if (isSeen()) return;
    if (cookieBarOpen()) { setTimeout(show, 2500); return; } // cerez karari verilene kadar erteleme
    overlay = $('sanoltra-popup-overlay');
    if (!overlay) return;
    triggered = true;
    overlay.style.display = 'flex';
    document.body.style.overflow = 'hidden';
    if (window.dataLayer) window.dataLayer.push({ event: 'sanoltra_popup_shown' });
  }

  window.sanoltraClosePopup = function () {
    if (!overlay) overlay = $('sanoltra-popup-overlay');
    if (overlay) overlay.style.display = 'none';
    document.body.style.overflow = '';
    markSeen();
  };

  function isMobile() { return window.innerWidth <= 768; }

  // Desktop: mouse-leave from top
  document.addEventListener('mouseleave', function (e) {
    if (isMobile()) return;
    if (!triggered && e.clientY < 5) show();
  });

  // Mobile: rapid scroll-up after meaningful page activity
  var lastScroll = 0;
  var scrolledDown = false;
  window.addEventListener('scroll', function () {
    var y = window.scrollY;
    if (!isMobile()) return;
    if (y > 800) scrolledDown = true;
    if (scrolledDown && y < lastScroll - 100) show();
    lastScroll = y;
  }, { passive: true });


  // Desktop: scroll 50% trigger (cold traffic backup)
  var desktopScrolled = false;
  window.addEventListener('scroll', function () {
    if (isMobile() || desktopScrolled || triggered) return;
    var maxScroll = document.documentElement.scrollHeight - window.innerHeight;
    if (maxScroll > 0 && (window.scrollY / maxScroll) >= 0.5) {
      desktopScrolled = true;
      show();
    }
  }, { passive: true });

  // Universal: timer
  setTimeout(show, TIMER_MS);

  // Form submit
  document.addEventListener('DOMContentLoaded', function () {
    var form = $('sanoltra-popup-form');
    if (!form) return;
    form.addEventListener('submit', function (ev) {
      ev.preventDefault();
      var email = $('sanoltra-popup-email').value.trim();
      var kvkk = $('sanoltra-popup-kvkk').checked;
      var msg = $('sanoltra-popup-msg');
      var btn = $('sanoltra-popup-submit-btn');

      msg.style.display = 'none';
      msg.className = 'sanoltra-popup-msg';

      if (!email || !/.+@.+\..+/.test(email)) {
        msg.textContent = 'Geçerli bir e-posta adresi giriniz.';
        msg.className = 'sanoltra-popup-msg error';
        msg.style.display = 'block';
        return;
      }
      if (!kvkk) {
        msg.textContent = 'KVKK onayı gereklidir.';
        msg.className = 'sanoltra-popup-msg error';
        msg.style.display = 'block';
        return;
      }

      btn.disabled = true;
      btn.textContent = 'Kaydediliyor...';

      // Klaviyo public Subscribe API
      var payload = {
        data: {
          type: 'subscription',
          attributes: {
            custom_source: 'Exit Intent Popup',
            profile: {
              data: {
                type: 'profile',
                attributes: {
                  email: email
                }
              }
            }
          },
          relationships: {
            list: { data: { type: 'list', id: NEWSLETTER_LIST_ID } }
          }
        }
      };

      fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + KLAVIYO_COMPANY_ID, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'revision': '2024-10-15'
        },
        body: JSON.stringify(payload)
      })
        .then(function (r) {
          if (r.ok || r.status === 202) {
            msg.innerHTML = '🎉 Teşekkürler! <a href="https://cdn.shopify.com/s/files/1/0926/6308/7467/files/Aile_Saglik_Rehberi_Sanoltra.pdf" target="_blank" style="color:#1E2A5E;text-decoration:underline">📥 Aile Sağlık Rehberi PDF\'inizi indirin</a>';
            msg.className = 'sanoltra-popup-msg success';
            msg.style.display = 'block';
            markSeen();
            if (window.dataLayer) window.dataLayer.push({ event: 'sanoltra_popup_subscribe', email: email });
            if (window.fbq) window.fbq('track', 'Lead', { content_name: 'Newsletter Signup', value: 1 });
            setTimeout(window.sanoltraClosePopup, 4000);
          } else {
            return r.text().then(function (t) { throw new Error(t); });
          }
        })
        .catch(function (err) {
          console.error('Sanoltra popup error:', err);
          msg.textContent = 'Bir hata oluştu, lütfen tekrar deneyin.';
          msg.className = 'sanoltra-popup-msg error';
          msg.style.display = 'block';
          btn.disabled = false;
          btn.textContent = 'Ücretsiz Rehberi Al';
        });
    });
  });
})();
